<div class="noactivity-mask">
  <div class="text-container">
    <div *ngIf="text" class="non-selectable">{{text}}</div>
    <div *ngIf="optionalText" class="non-selectable">{{optionalText}}</div>
  </div>
</div>
